import React, { Suspense } from 'react';

import { Loader2 } from 'lucide-react';
import { Outlet } from 'react-router-dom';

import { RoutePermissionGuard } from '@/modules/authorization/components/route-permission-guard';
import { AuthenticatedError } from '@/modules/common/pages/authenticated-error';
import { OnboardingSidebar } from '@/modules/onboarding/common/components/onboarding-sidebar';
import { useRootSelector } from '@/router/state/root/util/context/helpers';

const OnboardingPrivatePage: React.FC = () => {
  const onboardingMachine = useRootSelector(state => state.children.onboardingMachine);
  const context = onboardingMachine?.getSnapshot()?.context;

  if (!context) {
    return;
  }

  const handleRetry = () => {
    onboardingMachine!.send({ type: 'NEXT' });
  };

  if (context.isNonOnboardingError) {
    return <AuthenticatedError onRetry={handleRetry} isLoading={context.isLoading} />;
  }

  return (
    <div className="flex h-screen">
      <RoutePermissionGuard>
        <OnboardingSidebar currentStep={context.currentStep} />
        <div className="ml-[24rem] flex h-full flex-1 flex-col overflow-auto max-lg:ml-[18rem] max-md:ml-[12rem]">
          {context.isLoading && (
            <div className="flex h-full items-center justify-center">
              <Loader2 className="h-8 w-8 animate-spin text-primary" />
            </div>
          )}
          {!context.isLoading && (
            <Suspense
              fallback={
                <div className="flex h-full items-center justify-center">
                  <Loader2 className="h-8 w-8 animate-spin text-primary" />
                </div>
              }
            >
              <Outlet />
            </Suspense>
          )}
        </div>
      </RoutePermissionGuard>
    </div>
  );
};

export default OnboardingPrivatePage;
